// DLD-422: TCPA audit trail.
// Single source of truth for the disclosure text shown next to the SMS-consent
// checkbox on every SOTSVC form. The exact text below is what gets sent to the
// backend as `consent_text`, so any wording change MUST bump SOTSVC_SMS_CONSENT_VERSION.
//
// Forms render `SOTSVC_SMS_CONSENT_TEXT` to the user (verbatim). At submit time,
// they send the same string + version + window.location.href so the lead row
// captures exactly what the user agreed to.

export const SOTSVC_SMS_CONSENT_VERSION = 'v1.0.0';

export const SOTSVC_SMS_CONSENT_TEXT =
  'I agree to receive text messages from Sonz of Thunder Services at the phone number provided, ' +
  'including appointment confirmations, service quotes, missed-call follow-ups, and post-service ' +
  'review requests. Message frequency varies. Message and data rates may apply. Reply STOP to opt out, ' +
  'HELP for help. See Privacy Policy at https://sotsvc.com/privacy and Terms of Service at ' +
  'https://sotsvc.com/terms.';

export function getConsentSourceUrl(): string {
  if (typeof window === 'undefined') return '';
  return window.location.href;
}
